import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormDataLink } from './form-data-link'

export class FormDataLinksRepository extends BaseRepository<FormDataLink> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/form-data-links', token, cache)
    }
}
